import React, { memo } from 'react';
import { Streamdown } from 'streamdown';

interface StreamdownMessageProps {
  content: string;
  isStreaming?: boolean;
  className?: string;
}

export const StreamdownMessage = memo(function StreamdownMessage({
  content,
  isStreaming = false,
  className,
}: StreamdownMessageProps) {
  return (
    <Streamdown
      isAnimating={isStreaming}
      className={className}
      shikiTheme={['github-light', 'github-dark']}
    >
      {content}
    </Streamdown>
  );
});
